export const howItWorks = {
  hero: {
    badge: "Πλήρης οδηγός",
    title: "Πώς λειτουργεί το DONKEY TRAVEL;",
    subtitle:
      "Ανακαλύψτε βήμα προς βήμα πώς να ανταλλάξετε το σπίτι σας Airbnb με άλλους ιδιοκτήτες και να ταξιδέψετε δωρεάν σε όλη την Ευρώπη.",
    cta: "Ξεκινήστε τώρα",
    learnMore: "Δείτε τα βήματα",
  },
  stats: {
    properties: "Διαθέσιμα καταλύματα",
    exchanges: "Πραγματοποιημένες ανταλλαγές",
    countries: "Καλυπτόμενες χώρες",
    satisfaction: "Ικανοποίηση",
  },
  steps: {
    badge: "Η διαδικασία",
    title: "Η ανταλλαγή σας σε 7 βήματα",
    subtitle:
      "Μια απλή και ασφαλής διαδρομή, από την εγγραφή μέχρι το πρώτο σας δωρεάν ταξίδι",
    step1: {
      title: "Δημιουργήστε το προφίλ σας (15 λεπτά)",
      description:
        'Είναι το πιο "μακρύ" βήμα: 15 λεπτά για να δημιουργήσετε το προφίλ σας. Μια μικρή προσπάθεια για χρόνια δωρεάν διακοπών και ευτυχίας!',
      highlight1: "Συνδρομή απαραίτητη",
      highlight2: "Πλήρης αγγελία με φωτογραφίες",
      highlight3: "Επαλήθευση ταυτότητας",
      badge: "Γρήγορη εγγραφή",
    },
    step2: {
      title: "Εξερευνήστε και βρείτε τον ιδανικό προορισμό σας",
      description:
        "Περιηγηθείτε στον διαδραστικό χάρτη της Ευρώπης και βρείτε επαληθευμένους οικοδεσπότες του συλλόγου. Φιλτράρετε ανά προορισμό, ημερομηνίες, τύπο καταλύματος και εξοπλισμό για να οργανώσετε την ανταλλαγή σας.",
      highlight1: "Διαδραστικός χάρτης Ευρώπης με προηγμένα φίλτρα",
      highlight2: "Αναζήτηση ανά προορισμό, ημερομηνίες και εξοπλισμό",
      highlight3:
        "Επαληθευμένα μέλη οικοδεσπότες στις διαθέσιμες ευρωπαϊκές χώρες",
      badge: "Έξυπνη αναζήτηση",
    },
    step3: {
      title: "Προτείνετε μια ανταλλαγή και διαπραγματευτείτε",
      description:
        "Επικοινωνήστε με τον ιδιοκτήτη που σας ενδιαφέρει και προτείνετε μια ανταλλαγή. Διαπραγματευτείτε τις ημερομηνίες και τη διάρκεια σε φιλικό πνεύμα. 10 νύχτες έναντι 5; Όλα είναι δυνατά!",
      highlight1: "Ενσωματωμένα και ασφαλή μηνύματα",
      highlight2: "Ευέλικτη διαπραγμάτευση διάρκειας",
      highlight3: "Επαληθευμένα προφίλ και κριτικές",
      badge: "Εύκολη διαπραγμάτευση",
    },
    step4: {
      title: "Επιβεβαιώστε τις ημερομηνίες και συγχρονίστε τα ημερολόγιά σας",
      description:
        "Μόλις επέλθει συμφωνία, επιβεβαιώστε τις ημερομηνίες ανταλλαγής. Τα ημερολόγιά σας Airbnb και DONKEY TRAVEL συγχρονίζονται αυτόματα για την αποφυγή διπλοκρατήσεων.",
      highlight1: "Αυτόματος συγχρονισμός με Airbnb",
      highlight2: "Υπενθυμίσεις και ειδοποιήσεις πριν τη διαμονή",
      highlight3: "Ευέλικτη τροποποίηση έως 48 ώρες πριν",
      badge: "Συγχρονισμένο ημερολόγιο",
    },
    step5: {
      title: "Φιλικό συμβόλαιο PDF που αποστέλλεται και στους δύο οικοδεσπότες",
      description:
        "Το DONKEY TRAVEL εκδίδει ένα φιλικό συμβόλαιο σε PDF και το στέλνει και στους δύο οικοδεσπότες. Μόλις ολοκληρωθεί η πρώτη ανταλλαγή, έχετε 24 μήνες για να πραγματοποιήσετε την ανταλλαγή επιστροφής.",
      highlight1:
        "Φιλικό συμβόλαιο PDF που αποστέλλεται αυτόματα στους 2 οικοδεσπότες",
      highlight2: "Έγγραφο σύνοψης ημερομηνιών και επικυρωμένων όρων",
      highlight3:
        "24 μήνες για την πραγματοποίηση της ανταλλαγής επιστροφής μετά την πρώτη διαμονή",
      badge: "Συμβόλαιο PDF",
    },
    step6: {
      title: "Ταξιδέψτε και απολαύστε τη δωρεάν διαμονή σας!",
      description:
        "Είναι η μεγάλη μέρα! Εγκατασταθείτε στο κατάλυμα ανταλλαγής και απολαύστε αυθεντικές διακοπές. Μετά τη διαμονή σας, αφήστε μια κριτική για να βοηθήσετε την κοινότητα.",
      highlight1: "Προσωποποιημένη υποδοχή από τον ιδιοκτήτη",
      highlight2: "Τοπικός οδηγός με συστάσεις",
      highlight3: "Σύστημα κριτικών μετά από κάθε ανταλλαγή",
      badge: "Καλό ταξίδι!",
    },
  },
  advantages: {
    badge: "Τα πλεονεκτήματά μας",
    title: "Γιατί να επιλέξετε το DONKEY TRAVEL;",
    subtitle:
      "Μια πλατφόρμα σχεδιασμένη για ιδιοκτήτες Airbnb που θέλουν να ταξιδέψουν διαφορετικά",
    items: {
      security: {
        title: "Μέγιστη ασφάλεια",
        description:
          "Όλα τα μέλη είναι επαληθευμένοι ιδιοκτήτες Airbnb. Ελεγμένη ταυτότητα, επαληθευμένες κριτικές και ασφάλεια που περιλαμβάνεται σε κάθε ανταλλαγή.",
      },
      savings: {
        title: "Σημαντική εξοικονόμηση",
        description:
          "Ταξιδέψτε δωρεάν ανταλλάσσοντας τις νύχτες σας. Εξοικονομήστε κατά μέσο όρο 2.500€ ετησίως στα έξοδα διαμονής.",
      },
      community: {
        title: "Κοινότητα εμπιστοσύνης",
        description:
          "Γίνετε μέλος της κοινότητας ταξιδιωτών μας. Μοιραστείτε τις εμπειρίες σας, ανταλλάξτε συμβουλές και δημιουργήστε μακροχρόνιους δεσμούς.",
      },
      support: {
        title: "Υποστήριξη 7/7",
        description:
          "Η ομάδα μας είναι διαθέσιμη ανά πάσα στιγμή για να σας συνοδεύσει. Ζωντανή συνομιλία, email και τηλέφωνο για πλήρη βοήθεια.",
      },
      quality: {
        title: "Ποιοτικά καταλύματα",
        description:
          "Κάθε κατάλυμα ελέγχεται και βαθμολογείται από την κοινότητα. Υψηλά πρότυπα για την εξασφάλιση εξαιρετικών διαμονών.",
      },
      global: {
        title: "Ευρωπαϊκό δίκτυο",
        description:
          "Αποκτήστε πρόσβαση σε επαληθευμένους οικοδεσπότες στις διαθέσιμες ευρωπαϊκές χώρες του συλλόγου και οργανώστε τις ανταλλαγές σας με εμπιστοσύνη.",
      },
    },
  },
  testimonials: {
    badge: "Μαρτυρίες",
    title: "Δοκίμασαν και ενέκριναν",
    subtitle: "Ανακαλύψτε τις εμπειρίες των μελών μας σε όλο τον κόσμο",
    banner: {
      title: "Μπορείτε κι εσείς να ταξιδεύετε πιο συχνά!",
      subtitle:
        "Γίνετε μέλος της κοινότητας οικοδεσποτών που ταξιδεύουν αλλιώς.",
    },
    items: {
      sophie: {
        name: "Sophie",
        location: "Παρίσι, Γαλλία",
        badge: "2 ανταλλαγές",
        text: "Χάρη στο DONKEY TRAVEL, επισκέφτηκα τη Βαρκελώνη, τη Ρώμη και το Άμστερνταμ χωρίς να πληρώσω διαμονή. Η κοινότητα είναι άμεσα ανταποκρινόμενη και οι συζητήσεις εύκολες.",
      },
      marc: {
        name: "Marc",
        location: "Μασσαλία, Γαλλία",
        badge: "1 ανταλλαγή",
        text: "Η διαδικασία είναι απίστευτα απλή. Σε 3 μέρες βρήκα την τέλεια ανταλλαγή για τις καλοκαιρινές μου διακοπές. Ο συγχρονισμός με το Airbnb είναι τεράστιο πλεονέκτημα.",
      },
      leaTom: {
        name: "Léa & Tom",
        location: "Λυών, Γαλλία",
        badge: "Νέα μέλη",
        text: "Αυτό που μας εντυπωσίασε περισσότερο είναι η κοινότητα. Οι ιδιοκτήτες είναι διακριτικοί, και οι ανταλλαγές γίνονται σε κλίμα απόλυτης εμπιστοσύνης.",
      },
      dupont: {
        name: "Οικογένεια Dupont",
        location: "Μπορντό, Γαλλία",
        badge: "3 ανταλλαγές",
        text: "Τέλειο για οικογενειακά ταξίδια κατά τη διάρκεια των σχολικών διακοπών!",
      },
      alex: {
        name: "Alex",
        location: "Βερολίνο, Γερμανία",
        badge: "5 ανταλλαγές",
        text: "Ένα απίστευτο δίκτυο για τηλεργασία. Ανταλλάσσω το λοφτ μου στο Βερολίνο με διαμερίσματα στον ήλιο.",
      },
      marie: {
        name: "Marie",
        location: "Τουλούζη, Γαλλία",
        badge: "4 ανταλλαγές",
        text: "Τέλος οι οικονομικοί περιορισμοί! Πηγαίνω ταξίδι κάθε μήνα το Σαββατοκύριακο.",
      },
      testimonial2: {
        text: "Η διαδικασία είναι τόσο απλή. Σε 3 μέρες, βρήκα μια τέλεια ανταλλαγή για τις καλοκαιρινές μου διακοπές. Ο συγχρονισμός με την Airbnb είναι ένα πραγματικό πλεονέκτημα.",
      },
      testimonial3: {
        text: "Αυτό που με γοήτευσε περισσότερο ήταν η κοινότητα. Οι ιδιοκτήτες είναι καλοπροαίρετοι και οι ανταλλαγές γίνονται σε κλίμα απόλυτης εμπιστοσύνης.",
      },
    },
  },
  faq: {
    title: "Συχνές ερωτήσεις",
    subtitle: "Όλα όσα πρέπει να γνωρίζετε πριν ξεκινήσετε",
    items: {
      q1: {
        question: "Η εγγραφή είναι επί πληρωμή;",
        answer:
          "Ναι. Η πρόσβαση στο DONKEY TRAVEL γίνεται μέσω ετήσιας συνδρομής. Προσφορά γνωριμίας 2026: 25EUR/έτος αντί για 50EUR/έτος.",
      },
      q2: {
        question: "Πρέπει να είμαι ιδιοκτήτης Airbnb για να εγγραφώ;",
        answer:
          "Ναι, το DONKEY TRAVEL προορίζεται για ιδιοκτήτες με καταχωρημένο ακίνητο στην Airbnb. Αυτό εγγυάται την ποιότητα και την αξιοπιστία κάθε μέλους της κοινότητας.",
      },
      q3: {
        question: "Πώς προστατεύονται οι ανταλλαγές;",
        answer:
          "Κάθε ανταλλαγή καλύπτεται από την ασφάλεια του συνεργάτη μας. Επιπλέον, όλα τα μέλη επαληθεύονται (ταυτότητα, κατάλυμα, κριτικές Airbnb) και η ομάδα υποστήριξής μας είναι διαθέσιμη 7/7.",
      },
      q4: {
        question: "Μπορώ να κάνω ανταλλαγή με κάποιον σε άλλη χώρα;",
        answer:
          "Ναι. Μπορείτε να κάνετε ανταλλαγή με άλλους επαληθευμένους οικοδεσπότες στις διαθέσιμες ευρωπαϊκές χώρες ανάλογα με τη συνδρομή σας.",
      },
      q5: {
        question: "Τι συμβαίνει αν ακυρωθεί η ανταλλαγή;",
        answer:
          "Η πολιτική ακύρωσής μας προστατεύει και τα δύο μέρη. Σε περίπτωση ακύρωσης, σας βοηθάμε να βρείτε μια εναλλακτική λύση.",
      },
      q6: {
        question: "Πόσο διαρκεί μια ανταλλαγή κατά μέσο όρο;",
        answer:
          "Η διάρκεια είναι πλήρως ευέλικτη και διαπραγματεύεται μεταξύ των δύο ιδιοκτητών. Κατά μέσο όρο, οι ανταλλαγές διαρκούν μεταξύ 5 και 14 διανυκτερεύσεων, αλλά κάποιοι κάνουν ανταλλαγές για ένα Σαββατοκύριακο ή έναν ολόκληρο μήνα.",
      },
    },
  },
  cta: {
    title: "Έτοιμοι να ταξιδέψετε δωρεάν;",
    subtitle: "Γίνετε μέλος της κοινότητας ταξιδιωτών μας.",
    explore: "Εξερεύνηση προορισμών",
    members: "Ενεργά μέλη",
    countries: "Διαθέσιμες χώρες",
    satisfaction: "Ικανοποίηση",
  },
};
